import type { Event } from 'services/api';

/** True when the request should be treated as expired in the UI (status or API copy). */
export function isEventExpiredForUi (event: Event): boolean {
  if (event.status === 'EXPIRED') return true;
  const norm = (s: string | undefined) => (s ?? '').trim().toLowerCase();
  return norm(event.waitingOn) === 'expired' || norm(event.eventStatusLabel) === 'expired';
}
